/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimilarRequestSource
 */
export interface SimilarRequestSource {
    /**
     * 
     * @type {string}
     * @memberof SimilarRequestSource
     */
    externalDocumentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimilarRequestSource
     */
    externalDocumentSectionName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimilarRequestSource
     */
    documentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimilarRequestSource
     */
    caseName?: string | null;
}

export function SimilarRequestSourceFromJSON(json: any): SimilarRequestSource {
    return SimilarRequestSourceFromJSONTyped(json, false);
}

export function SimilarRequestSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarRequestSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'externalDocumentName': !exists(json, 'externalDocumentName') ? undefined : json['externalDocumentName'],
        'externalDocumentSectionName': !exists(json, 'externalDocumentSectionName') ? undefined : json['externalDocumentSectionName'],
        'documentName': !exists(json, 'documentName') ? undefined : json['documentName'],
        'caseName': !exists(json, 'caseName') ? undefined : json['caseName'],
    };
}

export function SimilarRequestSourceToJSON(value?: SimilarRequestSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'externalDocumentName': value.externalDocumentName,
        'externalDocumentSectionName': value.externalDocumentSectionName,
        'documentName': value.documentName,
        'caseName': value.caseName,
    };
}


